import { render, staticRenderFns } from "./UserActionLogList.vue?vue&type=template&id=3b39edaf&"
import script from "./UserActionLogList.vue?vue&type=script&lang=js&"
export * from "./UserActionLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports